import { useState } from "react";
import { ChevronDown, ChevronRight, User } from "lucide-react";
import { fmtDate } from "@/lib/api";
import { useMember } from "@/pages/Member";

const Node = ({ n, depth }) => {
  const [open, setOpen] = useState(depth < 2);
  const has = n.children.length > 0;
  return (
    <li>
      <button onClick={() => setOpen(!open)} className="flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left text-sm hover:bg-slate-50" data-testid={`tree-node-${n.distributor_id}`}>
        {has ? (open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />) : <span className="w-4" />}
        <User className={`h-4 w-4 ${n.status === "approved" ? "text-emerald-600" : "text-slate-400"}`} />
        <span className="font-semibold">{n.name}</span>
        <span className="text-xs text-slate-500">{n.distributor_id} · {n.district} · {n.status === "approved" ? "Active" : "Inactive"} · {fmtDate(n.joined)}</span>
      </button>
      {has && open && <ul className="ml-5 border-l border-slate-200 pl-3">{n.children.map((c, i) => <Node key={i} n={c} depth={depth + 1} />)}</ul>}
    </li>
  );
};

export const MemberTeam = () => {
  const [t] = useMember("/mlm/me/tree");
  if (!t) return <p className="text-slate-500">Loading…</p>;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="member-tree">
      <h3 className="mb-3 font-display font-bold">Team network tree</h3>
      <p className="mb-3 rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white">{t.root.name} · {t.root.distributor_id} (you)</p>
      {t.children.length ? <ul className="ml-2">{t.children.map((c, i) => <Node key={i} n={c} depth={1} />)}</ul> : <p className="text-sm text-slate-500">Your team is empty. Members who register with your referral ID appear here.</p>}
    </div>
  );
};
